export default "__VITE_ASSET__BDXsJ4FU__"